<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <div [hidden]="edit.is_new === '0'">
            <tt-input ttLabel="languageid" [(ttModel)]="edit.language_id" ttRequired></tt-input>
            <tt-input ttLabel="language_name" [(ttModel)]="edit.language_name" ttRequired></tt-input>
        </div>

        <div [hidden]="edit.is_new === '1'">
            <tt-input ttLabel="languageid" [ttModel]="edit.language_id" ttReadonly></tt-input>
            <tt-input ttLabel="language_name" [(ttModel)]="edit.language_name" [ttButtons]="languageNameButtons" ttRequired></tt-input>
        </div>

        <tt-input-number ttLabel="sortorder" [(ttModel)]="edit.sortorder" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-select ttLabel="date_format" [(ttModel)]="edit.date_format" [ttData]="selectListDateFormats" ttDataId="date_format" ttDataName="date_format_name"></tt-select>
        <tt-button-save ttText="language_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <div ng-if="vm.model.edit.is_new === '0'">
            <tt-input class="col-xs-12 sp-0" tt-label="languageid" tt-model="vm.model.edit.language_id" tt-change="vm.model.edit.language_id = $value" tt-readonly="true"></tt-input>
        </div>

        <div ng-if="vm.model.edit.is_new === '1'">
            <tt-input class="col-xs-12 sp-0" tt-label="languageid" tt-model="vm.model.edit.language_id" tt-change="vm.model.edit.language_id = $value" tt-readonly="false"></tt-input>
        </div>

        <tt-input-buttons class="col-xs-12 sp-0" tt-label="language_name" tt-model="vm.model.edit.language_name" tt-change="vm.model.edit.language_name = $value" tt-placeholder="" tt-buttons="vm.model.languageNameButtons" tt-readonly="false"></tt-input-buttons>
        <tt-input-number class="col-xs-12 sp-0" tt-label="sortorder" tt-model="vm.model.edit.sortorder" tt-change="vm.model.edit.sortorder = $value" tt-placeholder="" tt-style="" tt-text-align="right" tt-options="{ decimals: 0 }" tt-readonly="false"></tt-input-number>
        <tt-select class="col-xs-12 sp-0" tt-label="date_format" tt-model="vm.model.edit.date_format" tt-change="vm.model.edit.date_format = $value" tt-data="vm.model.selectListDateFormats" tt-data-id="date_format" tt-data-name="date_format_name"></tt-select>
        <tt-button-save class="col-xs-12 sp-0" tt-text="language_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
